import React from "react"
import { Link } from "gatsby"
import * as Icon from "react-feather"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from "react-accessible-accordion"
import Layout from "../components/_App/layout"
import Seo from "../components/_App/seo"
import Navbar from "../components/_App/Navbar"
import Footer from "../components/_App/Footer"
import PageBanner from "../components/Common/PageBanner"
import creativeServices from "../data/creative-services"

import ServicesDetails1 from "../images/services-details-image/services-details1.png"

const iconBgs = ["", "", "", "bg-c679e3", "bg-c679e3", "bg-c679e3"]

const processSteps = [
  { icon: "MessageCircle", title: "Discuss", text: "Tell us about your goals, audience, budget and timeline." },
  { icon: "Edit", title: "Plan", text: "We share the concept, mood board and schedule for approval." },
  { icon: "Aperture", title: "Create", text: "Our team designs, shoots or edits your project with care." },
  { icon: "CheckCircle", title: "Deliver", text: "Review, request revisions and receive final files on time." },
]

const ServicePage = ({ pageContext }) => {
  const service = creativeServices.find(s => s.slug === pageContext.slug)
  const others = creativeServices.filter(s => s.slug !== service.slug)

  return (
    <Layout>
      <Navbar />

      <PageBanner pageTitle={service.title} />

      {/* Intro */}
      <div className="services-details-area ptb-80">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 services-details">
              <div className="services-details-desc">
                <h3>{service.title} Services</h3>
                {service.intro.map((para, i) => (
                  <p key={i}>{para}</p>
                ))}
                <Link to="/contact" className="btn btn-primary mt-3">
                  Book a Free Consultation
                </Link>
              </div>
            </div>

            <div className="col-lg-6 services-details-image">
              <img
                src={ServicesDetails1}
                className="animate__animated animate__fadeInUp"
                alt={service.title}
              />
            </div>
          </div>
        </div>
      </div>

      {/* What we offer */}
      <div className="services-area-two pt-80 pb-50 bg-f9f6f6">
        <div className="container">
          <div className="section-title">
            <h2>What We Offer</h2>
            <div className="bar"></div>
            <p>{service.summary}</p>
          </div>

          <div className="row justify-content-center">
            {service.offerings.map((item, i) => {
              const ItemIcon = Icon[item.icon] || Icon.Star
              return (
                <div className="col-lg-4 col-sm-6" key={item.title}>
                  <div className="single-services-box">
                    <div className={`icon ${iconBgs[i] || ""}`}>
                      <ItemIcon />
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>

      {/* How we work */}
      <div className="features-area pt-80 pb-50">
        <div className="container">
          <div className="section-title">
            <h2>How We Work</h2>
            <div className="bar"></div>
            <p>A simple, transparent process from first call to final delivery.</p>
          </div>

          <div className="row justify-content-center">
            {processSteps.map((step, i) => {
              const StepIcon = Icon[step.icon]
              return (
                <div className="col-lg-6 col-md-6" key={step.title}>
                  <div className="single-features">
                    <div className={`icon ${i % 2 ? "bg-c679e3" : ""}`}>
                      <StepIcon />
                    </div>
                    <h3>
                      {i + 1}. {step.title}
                    </h3>
                    <p>{step.text}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>

      {/* Packages */}
      <div className="pricing-area pt-80 pb-50 bg-f9f6f6">
        <div className="container">
          <div className="section-title">
            <h2>{service.title} Packages</h2>
            <div className="bar"></div>
            <p>
              Choose a package that fits your needs, or contact us for a custom
              quote.
            </p>
          </div>

          <div className="row justify-content-center">
            {service.packages.map(pkg => {
              const isNumber = /^[\d,]+$/.test(pkg.price)
              return (
                <div className="col-lg-4 col-md-6" key={pkg.name}>
                  <div
                    className={`pricing-table ${
                      pkg.featured ? "active-plan" : ""
                    }`}
                  >
                    <div className="pricing-header">
                      <h3>{pkg.name}</h3>
                    </div>

                    <div className="content">
                      <div className="price">
                        <span>
                          {isNumber && <sup>₹</sup>}
                          {pkg.price} {pkg.unit && <span>{pkg.unit}</span>}
                        </span>
                      </div>

                      <div className="pricing-features">
                        <ul>
                          {pkg.features.map(feature => (
                            <li className="active" key={feature}>
                              {feature}
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="pricing-footer">
                        <Link to="/contact" className="btn btn-primary">
                          Get a Quote
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className="services-details-area ptb-80">
        <div className="container">
          <div className="section-title">
            <h2>Frequently Asked Questions</h2>
            <div className="bar"></div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="services-details-desc">
                <div className="services-details-accordion">
                  <Accordion allowZeroExpanded preExpanded={["faq-0"]}>
                    {service.faqs.map((faq, i) => (
                      <AccordionItem uuid={`faq-${i}`} key={faq.q}>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            <span>{faq.q}</span>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>{faq.a}</p>
                        </AccordionItemPanel>
                      </AccordionItem>
                    ))}
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Other services */}
      <div className="solutions-area pt-80 pb-50 bg-f9f6f6">
        <div className="container">
          <div className="section-title">
            <h2>Explore Other Services</h2>
            <div className="bar"></div>
          </div>

          <div className="row justify-content-center">
            {others.map(other => {
              const OtherIcon = Icon[other.icon] || Icon.Star
              return (
                <div className="col-lg-4 col-sm-6" key={other.slug}>
                  <div className="single-services-box">
                    <div className={`icon ${other.iconBg}`}>
                      <OtherIcon />
                    </div>
                    <h3>
                      <Link to={`/services/${other.slug}`}>{other.title}</Link>
                    </h3>
                    <p>{other.summary}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="cta-area ptb-80">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-6">
              <div className="cta-content">
                <h3>Ready to start your {service.title.toLowerCase()} project?</h3>
              </div>
            </div>

            <div className="col-lg-5 col-md-6">
              <div className="cta-right-content">
                <div className="buy-btn">
                  <Link to="/contact" className="btn btn-primary">
                    Let's Talk
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </Layout>
  )
}

export const Head = ({ pageContext }) => {
  const service = creativeServices.find(s => s.slug === pageContext.slug)
  return <Seo title={service.title} description={service.summary} />
}

export default ServicePage
